export default __webpack_public_path__ + "static/media/payment-gateway.43ce1aa3.png";